import React from 'react';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import FirstSectionPanel from './FirstSectionPanel.js';
import {  getCrystalImage } from '../../../../api/ispyb.js';


export default class SampleDataCollectionGroupPanel extends React.Component {
    render() {          
        return <Grid fluid style={{marginTop:'15px'}}>                   
                    <Row>
                         <Col  xs={12} sm={6} md={2}>
                                <FirstSectionPanel {...this.props}></FirstSectionPanel>
                        </Col>
                        <Col  xs={12} sm={6} md={2}>
                                { this.props.configuration.settings.MX.showCrystalSnapshot1 &&
                                        <Image thumbnail src={getCrystalImage(this.props.user, this.props.proposal, this.props.datacollectiongroup.dataCollectionId, 1)} />                             
                                }
                        </Col>
                        <Col  xs={12} sm={6} md={2}>
                                { this.props.configuration.settings.MX.showCrystalSnapshot2 &&
                                        <Image thumbnail src={getCrystalImage(this.props.user, this.props.proposal, this.props.datacollectiongroup.dataCollectionId, 2)} />
                                }
                        </Col>
                       <Col  xs={12} sm={6} md={2}>
                                { this.props.configuration.settings.MX.showCrystalSnapshot3 &&
                                        <Image thumbnail src={getCrystalImage(this.props.user, this.props.proposal, this.props.datacollectiongroup.dataCollectionId, 3)} />
                                }
                        </Col>
                       <Col  xs={12} sm={6} md={2}>
                                { this.props.configuration.settings.MX.showCrystalSnapshot4 &&
                                        <Image thumbnail src={getCrystalImage(this.props.user, this.props.proposal, this.props.datacollectiongroup.dataCollectionId, 4)} />
                                }
                        </Col>
                       
                    </Row>
                    <Row>
                        <Col>
                            Comments
                        </Col>
                    </Row>
            </Grid>;
    }
}





// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SampleDataCollectionGroup/SampleDataCollectionGroupPanel.js